import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { User } from '@app/models/user.model';
import { Subject, takeUntil } from 'rxjs';
import { DaiDbService } from '@app/services/indexdb/dai-db.service';

@Component({
  selector: 'app-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.scss'],
})
export class UserItemComponent implements OnInit, OnDestroy {
  @Input() user!: User;
  @Input() selected: boolean = false;
  @Input() multiSeletect: boolean = false;
  private _userImage: string | undefined = undefined;
  private onDestory$: Subject<void>;
  get userImage() {
    return this._userImage;
  }
  constructor(
    private daiIndexService: DaiDbService,
    private cd: ChangeDetectorRef,
  ) {
    this.onDestory$ = new Subject();
  }

  ngOnDestroy(): void {
    this.onDestory$.next();
  }

  async ngOnInit(): Promise<void> {
    const { daicd } = this.user;
    // check init
    this.daiIndexService.addUser$.pipe(takeUntil(this.onDestory$)).subscribe(async (currentDaicd: string) => {
      if (currentDaicd === daicd) {
        this._userImage = (await this.daiIndexService.getDaiInfo(daicd))?.image;
        this.cd.detectChanges();
      }
    });
    // check update
    this.daiIndexService.cursor(IDBKeyRange.only(daicd)).onsuccess = (event: any) => {
      if (event.target.result) {
        this._userImage = event.target.result.value['image'];
      }
    }
  }
}
